import axios from 'axios'

const state = {
	list: [],
};

const mutations = {
	SET_LIST: (state, list) => {
		state.list = list;
	},
}

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {
	
	getSites(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/sites/index', payload, options)
			.then((response) => {
				return response
			})
	},

	getSitesWithTechnicians(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL+'/sites', payload, options)
			.then((response) => {
				return response
			})
	},

	getSitesContracts(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL+'/sites/contracts/' + payload.client_id, payload, options)
			.then((response) => {
				return response
			})
	},

	getSiteDetails(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/sites/' + payload)
			.then((response) => {
				return response
			})
	},

	getSiteInformation(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/sites/' + payload.siteId + '/information')
			.then((response) => {
				return response
			})
	},

    getSiteInterventions(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/sites/' + payload.id + '/interventions', {
            page: payload.page,
            perPage: payload.perPage,
            search: payload.search
        }, options).then((response) => {
            return response
        })
    },

	fetchAllSites(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/sites/fetch/all')
			.then((response) => {
				return response
			})
	},

	fetchAllSitesForDuplication(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/sites/fetch/duplication/' + payload.siteId)
			.then((response) => {
				return response
			})
	},

	updateSite(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/' + payload.id, payload, options)
			.then((response) => {
				return response
			})
	},

	updateSchedules(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/' + payload.id + '/schedules', payload, options)
			.then((response) => {
				return response
			})
	},

	updateContacts(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/' + payload.id + '/contacts', payload, options)
			.then((response) => {
				return response
			})
	},

	updateTechnicians(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/' + payload.id + '/technicians', payload, options)
			.then((response) => {
				return response
			})
	},

	updateNote(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/note/' + payload.id, payload, options)
			.then((response) => {
				return response
			})
	},

	updateSector(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/' + payload.id + '/sector', payload, options)
			.then((response) => {
				return response
			})
	},
	
	updateDevicesProducts(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/' + payload.siteId + '/devices_products', payload, options)
			.then((response) => {
				return response
			})
	},
	
	createClientAreaAccount(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/sites/' + payload.site_id + '/client-area', payload, options)
			.then((response) => {
				return response
			})
	},

	duplicateSite(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/sites/' + payload.targetSiteId + '/duplicate', {
			site_id: payload.site_id
		}, options)
			.then((response) => {
				return response
			})
	},
}

const getters = {
	list: state => state.list,
};

const sites = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default sites;
